import React, { useEffect } from "react";
import Iframe from "react-iframe";

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  container: {
    // width: "60%",
    width: "100%",
    float: "right",
    height: "calc(100vh - 210px)",
    [theme.breakpoints.down('md')]: {
        // width: "100%",
        float: "none"
    },
    left: "0px",
    top: "0px",
    zIndex: 100,
    position: "relative",
  },
  iframe: {
    border: "none",
    left: "0px",
    top: "0px",
    zIndex: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
  }
}));

// InDoc Wrapper Component
const InDoc = props => {
  const classes = useStyles();

  useEffect(() => {
    const checkChange = () => {
      if(window.innerHeight !== window.screen.height) { 
        setTimeout(() => {
          const elem = document.getElementById('indoc_container');
          elem.style = "";
        }, 200);
      }
    }

    const listener = document.addEventListener("fullscreenchange", checkChange);

    return () => {
      document.removeEventListener('fullscreenchange', listener);
    }
  }, []);

  let IframeUrl = props.param ? `${props.url}${props.param}` : `${props.url}`;

  return (
    <React.Fragment>
      <div
        id="indoc_container"
        className={classes.container}
      >
        <Iframe url={IframeUrl} id="indoc" className={classes.iframe} title="Interactive Document" allowFullScreen />
      </div>
    </React.Fragment>
  );
};

export default InDoc;
